import { render, staticRenderFns } from "./ebp-note-button.vue?vue&type=template&id=07bccade"
import script from "./ebp-note-button.vue?vue&type=script&lang=js"
export * from "./ebp-note-button.vue?vue&type=script&lang=js"
import style0 from "./ebp-note-button.vue?vue&type=style&index=0&id=07bccade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports